import { Box, Text, Group } from '@mantine/core'
import { aiVars } from '@/theme'

const COLORS: Record<string, string> = {
  primary: aiVars.brandAzul,
  success: aiVars.successColor,
  warning: aiVars.warningColor,
  danger: aiVars.dangerColor,
  info: aiVars.infoColor,
}

interface TimelineItem {
  icon?: React.ReactNode
  color?: 'primary' | 'success' | 'warning' | 'danger' | 'info'
  title: string
  time?: string
  content?: React.ReactNode
}

interface TimelineProps {
  items: TimelineItem[]
}

export function Timeline({ items }: TimelineProps) {
  return (
    <Box style={{ position: 'relative', paddingLeft: 28 }}>
      {/* Vertical line */}
      <Box
        style={{
          position: 'absolute',
          left: 11,
          top: 0,
          bottom: 0,
          width: 2,
          backgroundColor: 'var(--ai-border-light)',
        }}
      />

      {items.map((item, i) => {
        const dotColor = COLORS[item.color ?? 'primary']
        return (
          <Box key={i} style={{ position: 'relative', paddingBottom: 20 }}>
            {/* Dot */}
            <Box
              style={{
                position: 'absolute',
                left: -22,
                top: 4,
                width: 22,
                height: 22,
                borderRadius: '50%',
                backgroundColor: dotColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                zIndex: 1,
              }}
            >
              {item.icon ?? (
                <Box style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#fff' }} />
              )}
            </Box>

            {/* Content */}
            <Box style={{ paddingLeft: 12 }}>
              <Group justify="space-between" mb={4}>
                <Text size="sm" fw={600}>{item.title}</Text>
                {item.time && (
                  <Text size="xs" c="dimmed">{item.time}</Text>
                )}
              </Group>
              {item.content && (
                <Box
                  style={{
                    backgroundColor: 'var(--ai-body-bg)',
                    border: '1px solid var(--ai-border-light)',
                    borderRadius: 4,
                    padding: '8px 12px',
                  }}
                >
                  {item.content}
                </Box>
              )}
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}
